// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__3v0wQ","modal_main":"modal_modal_main__25Lu9","display_block":"modal_display_block__2ErBl","display_none":"modal_display_none__2fVg2"};